import { apiSlice } from "./apiSlice";
import { CUSTOMERS_URL } from "../constants";

const customersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCustomers: builder.query({
      query: (data) => ({
        url: `${CUSTOMERS_URL}?${data.query ? data.query : ""}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
    updateCustomer: builder.mutation({
      query: (data) => ({
        url: `${CUSTOMERS_URL}/${data._id}`,
        method: "PUT",
        body: data.payload,
        headers: {
          Authorization: `Bearer ${data.token}`,
        },
      }),
    }),
  }),
});

export const { useGetCustomersQuery, useUpdateCustomerMutation } =
  customersApiSlice;
